import Vue from 'vue'
import VueI18n from 'vue-i18n'
// import Cookies from 'js-cookie'
import elementEnLocale from 'element-ui/lib/locale/lang/en' // element-ui lang
import elementZhLocale from 'element-ui/lib/locale/lang/zh-CN'// element-ui lang
import elementSpanishLocale from 'element-ui/lib/locale/lang/sk'// element-ui lang //todo 是否是西班牙語
import enLocale from './en'
import zhLocale from './zh'
import spanishLocale from './spanish'

Vue.use(VueI18n)

const messages = {
  en: {
    ...enLocale,
    ...elementEnLocale
  },
  spanish: {
    ...spanishLocale,
    ...elementSpanishLocale
  },
  zh: {
    ...zhLocale,
    ...elementZhLocale
  }
}
export function getLanguage() {
  // const chooseLanguage = Cookies.get('etower-ubi-spww-language')
  const chooseLanguage = localStorage.getItem('etower-ubi-spww-language')
  if (chooseLanguage) return chooseLanguage

  // if has not choose language
  return 'en'
}
const i18n = new VueI18n({
  // set locale
  // options: en | zh | es
  locale: getLanguage(),
  // set locale messages
  messages
})

export default i18n
